import { DROPDOWN_OPTIONS } from '@constants/ssap/hhmTypes/dropdownOptions';
import React from 'react';
import { DropdownButton, Dropdown } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

const CustomDropdownButton = styled(DropdownButton)`
    .dropdown-toggle::after {
        display: none !important;  /* This is to hide the caret */
    }

    .gi-button__outline{
        line-height: 1;
        font-weight: 400;
        padding: 10px 16px;
        border-radius: 4px;
        @media screen and (max-width: 640px){
            width: 100%;
            margin-top: 10px;
            margin-bottom: 10px;
        }
    }
`;

const DropDownMenu = (props) => {

    const {
        onFieldChange, spokenOrWrittenLanguage, stateCode, type
    } = props;

    const handleSelect = (eventKey) => {
        onFieldChange(spokenOrWrittenLanguage, eventKey);
    };

    return (
        <CustomDropdownButton
            id={`${spokenOrWrittenLanguage}_dropdown_button`}
            data-testid={`${spokenOrWrittenLanguage}_dropdown`}
            title={<FormattedMessage id='ssap.button.change' />}
            bsPrefix="gi-button__outline"
            onSelect={handleSelect}
        >
            {DROPDOWN_OPTIONS.LANGUAGES_FILTERED(type, stateCode).map(language =>
                language.value !== 'default' &&
                <Dropdown.Item key={language.value} eventKey={language.value} data-testid={`${spokenOrWrittenLanguage}_option_${language.value}`} as="div" className='usa-button gi-button text-center'>
                    <FormattedMessage id={language.text} />
                </Dropdown.Item>
            )}
        </CustomDropdownButton>
    );
};

export default DropDownMenu;
